import { Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useModal, useToast } from "@/comn/hooks";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { APIS, SF_COMN_CD_MGMT_DTL_INFO, URLS } from "./services/OsciComnCdAppService";

/*
 * Modifying Common Code Valid Values
 * !== 공통 코드 유효 값 수정 ==!
 */
export const OSCI0109008S = (props: any) => {
    const pgeUid = "UI-OSCI-0109-008S";
    const { t } = useTranslation();
    const navigate = useNavigate();
    const modal = useModal();
    const toast = useToast();
    const { comnCd, cdVldVal } = useParams();
    // 상세 조회와 저장 요청에 동일한 7자리 공통코드를 사용하도록 URL 패딩을 제거한다.
    const normalizedComnCd = comnCd?.trim();

    const form = {
        comnCdMgmtDtlInfo: useForm({
            defaultSchema: SF_COMN_CD_MGMT_DTL_INFO,
        }),
    };

    const fetch = {
        // Check common code valid value information !== 공통 코드 유효 값 정보 조회 ==!
        getComnCdDtlInfo: useFetch({
            api: (data: any) => APIS.getComnCdDtlInfo(data),
            enabled: false,
            onSuccess: (data) => {
                const comnCdDtlInfo = data.comnCdDtl.content;
                form.comnCdMgmtDtlInfo.setValues({
                    ...comnCdDtlInfo,
                    comnCd: comnCdDtlInfo.comnCd?.trim(),
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00043" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
        // Save Common Code Valid Values !== 공통 코드 유효 값 저장 ==!
        saveComnCdDtl: useFetch({
            api: (data: any) => APIS.saveComnCdDtl(data),
            enabled: false,
            onSuccess: () => {
                modal.openModal({ content: "msg.osc.00069" }); // Successfully inserted. !== 정상적으로 등록되었습니다. ==!
                navigate(
                    URLS.osci0109007q +
                        "/" +
                        form.comnCdMgmtDtlInfo.getValue("comnCd") +
                        "/" +
                        form.comnCdMgmtDtlInfo.getValue("cdVldVal") +
                        "?ppup=Y",
                );
                modal.postMessage({});
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00035" }), // An error occurred. !== 에러가 발생했습니다! ==!
        }),
    };

    const handler = {
        // Save Common Code Valid Values !== 공통 코드 유효 값 저장 ==!
        saveComnCdDtl: () => {
            if (!comnUtils.isEmpty(form.comnCdMgmtDtlInfo.errors)) {
                toast.showToast({ type: "warning", content: "msg.osc.00003" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                return;
            }
            form.comnCdMgmtDtlInfo.handleSubmit(
                () => {
                    const data = form.comnCdMgmtDtlInfo.getValues();
                    modal.openModal({
                        content: "msg.osc.00090", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                        onConfirm: () => {
                            fetch.saveComnCdDtl.fetch(data);
                        },
                    });
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                },
            )();
        },
    };

    useEffect(() => {
        fetch.getComnCdDtlInfo.fetch({
            comnCd: normalizedComnCd,
            cdVldVal,
        });
    }, []);

    return (
        <Page
            id={pgeUid}
            title={t("T_COMN_CD_DTL_CHG")}
            navigation={{
                base: comnEnvs.base,
                nodes: [
                    { label: "Portal" },
                    { label: "Common Module" },
                    { label: "Code Management" },
                    { path: "/comnmdle/comncd/osci0109001q", label: "Common Code Management" },
                ],
            }}
        >
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control
                                {...form.comnCdMgmtDtlInfo.schema.comnCd}
                                defaultValue={normalizedComnCd}
                                edit={false}
                            />
                            <Group.Control
                                {...form.comnCdMgmtDtlInfo.schema.cdVldVal}
                                defaultValue={cdVldVal}
                                edit={false}
                            />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.comnCdMgmtDtlInfo.schema.cdVldValNmEn} />
                            <Group.Control {...form.comnCdMgmtDtlInfo.schema.cdVldValNmTz} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.comnCdMgmtDtlInfo.schema.cdVldValNmKo} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.comnCdMgmtDtlInfo.schema.useYn} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.comnCdMgmtDtlInfo.schema.vldStrtDt} />
                            <Group.Control {...form.comnCdMgmtDtlInfo.schema.vldEndDt} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.comnCdMgmtDtlInfo.schema.srtngOrd} />
                            <Group.Control {...form.comnCdMgmtDtlInfo.schema.usrDefnVldVal1} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.comnCdMgmtDtlInfo.schema.usrDefnVldVal2} />
                            <Group.Control {...form.comnCdMgmtDtlInfo.schema.usrDefnVldVal3} />
                        </Group.Row>
                    </Group.Section>
                    <Group.Section>
                        <Layout>
                            <Layout.Right>
                                <Layout.Button
                                    role="cancel"
                                    onClick={() => {
                                        navigate(`${URLS.osci0109007q}/${comnCd}/${cdVldVal}?ppup=Y`);
                                    }}
                                ></Layout.Button>
                                <Layout.Button role={"save"} onClick={handler.saveComnCdDtl} />
                            </Layout.Right>
                        </Layout>
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
